import { Box } from '@evaneos/b2b-ui';
import CalendarTodayIcon from '@evaneos/b2b-ui/icons/CalendarToday';
import SettingsOutlinedIcon from '@evaneos/b2b-ui/icons/SettingsOutlined';

import { AppointmentNavLink } from './AppointmentNavLink';

type Props = {
    isConnected: boolean;
};

export const AppointmentTabs = ({ isConnected }: Props): JSX.Element => (
    <Box
        component="nav"
        sx={{
            bgcolor: 'background.paper',
            borderBottom: '1px solid',
            borderColor: 'divider',
            display: 'flex',
            alignItems: 'center',
            flexShrink: 0,
            px: 4,
        }}
    >
        <AppointmentNavLink
            data-spec-id="agenda-tab-rendez-vous"
            to="list"
            className={isConnected ? undefined : 'disabled'}
            disabled={!isConnected}
        >
            <CalendarTodayIcon fontSize="small" />
            Mes rendez-vous
        </AppointmentNavLink>
        <AppointmentNavLink
            data-spec-id="agenda-tab-disponibilites"
            to="config"
            className={isConnected ? undefined : 'disabled'}
            disabled={!isConnected}
        >
            <SettingsOutlinedIcon fontSize="small" />
            Mes disponibilités
        </AppointmentNavLink>
    </Box>
);
